export default __webpack_public_path__ + "static/media/Millet.86eeb7ce.jpg";